import classnames from 'classnames'
import featureToggles from 'shared/featureToggles'
import {
    CUSTOMER_TYPE_CO_BUSINESS,
    CUSTOMER_TYPE_CO_CITIZEN,
    CUSTOMER_TYPE_BUSINESS,
    CUSTOMER_TYPE_INDIVIDUAL,
} from 'shared/constants'

import styles from 'login-and-signup/components/styles.module.scss'

export const IndividualOrBusiness = ({ customerType, setCustomerType }) => {
    if (!featureToggles.additionalSignupData || (featureToggles.hasSubcriptionLite && featureToggles.hasBusinessUser)) {
        return
    }

    if (featureToggles.brNeoPurchaseFlow) {
        return (
            <div className="d-flex" role="group" aria-labelledby="customerTypeLabel">
                <button
                    type="button"
                    onClick={() => setCustomerType(CUSTOMER_TYPE_INDIVIDUAL)}
                    className={classnames(styles.userType, {
                        [styles.selected]: customerType === CUSTOMER_TYPE_INDIVIDUAL,
                    })}
                    aria-pressed={customerType === CUSTOMER_TYPE_INDIVIDUAL}>
                    <T>auth.sign.up.type.individual</T>
                </button>
                <button
                    type="button"
                    onClick={() => setCustomerType(CUSTOMER_TYPE_BUSINESS)}
                    className={classnames(styles.userType, {
                        [styles.selected]: customerType === CUSTOMER_TYPE_BUSINESS,
                    })}
                    aria-pressed={customerType === CUSTOMER_TYPE_BUSINESS}>
                    <T>auth.sign.up.type.business</T>
                </button>
            </div>
        )
    }

    if (featureToggles.isColumbia) {
        return (
            <div className="d-flex" role="group" aria-labelledby="customerTypeLabel">
                <button
                    type="button"
                    onClick={() => setCustomerType(CUSTOMER_TYPE_CO_CITIZEN)}
                    className={classnames(styles.userType, {
                        [styles.selected]: customerType !== CUSTOMER_TYPE_CO_BUSINESS,
                    })}
                    aria-pressed={customerType !== CUSTOMER_TYPE_CO_BUSINESS}>
                    <T>auth.sign.up.type.individual</T>
                </button>
                <button
                    type="button"
                    onClick={() => setCustomerType(CUSTOMER_TYPE_CO_BUSINESS)}
                    className={classnames(styles.userType, {
                        [styles.selected]: customerType === CUSTOMER_TYPE_CO_BUSINESS,
                    })}
                    aria-pressed={customerType === CUSTOMER_TYPE_CO_BUSINESS}>
                    <T>auth.sign.up.type.business</T>
                </button>
            </div>
        )
    }
}

export default IndividualOrBusiness
